import ContentGroup from "@/classes/ContentGroup";
import Media from "../../classes/Media";

export interface StateInterface {
  mediaFiles: Array<Media | ContentGroup>;
}

function state(): StateInterface {
  return {
    mediaFiles: [],
  };
}

export default state;
